import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../../../lib/money';

const Refund = ({ refund }) => {
  if (!refund) return null;

  return (
    <p>
      <FormattedMessage
        id="autoPilot.refund.expectedRefund"
        defaultMessage="Your expected refund {refund}"
        values={{
          refund: <strong className="text-success">+{format(refund)}</strong>
        }}
      />{' '}
      <span className="cool-grey">
        <FormattedMessage
          id="autoPilot.refund.reason"
          defaultMessage="for past overpayment based on this group size"
        />
        {' '}
        <span role="img" aria-label="cheers">🎉</span>
      </span>
    </p>
  );
};

Refund.defaultProps = {
  refund: null,
};

export default Refund;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/refund.js